export default __webpack_public_path__ + "static/media/mastery.9ecad4a9.jpg";